import { Controller } from "@hotwired/stimulus"

// Mein Konto → Kalender-Zusammenfassung: hides what does not apply to the chosen rhythm —
// the hour and the contents while it is off, and the weekday unless it is weekly.
// Hidden fields still submit, so switching the digest off keeps the hour and contents for
// the next time it is switched on.
export default class extends Controller {
  static targets = ["frequency", "details", "weekday", "hour"]

  connect() {
    this.toggle()
  }

  toggle() {
    const frequency = this.frequencyTarget.value
    const off = frequency === "off"

    this.detailsTarget.classList.toggle("hidden", off)
    this.hourTarget.classList.toggle("hidden", off)
    this.weekdayTarget.classList.toggle("hidden", frequency !== "weekly")
  }
}
